import { Color } from './types';

export const darkGray: Color = '#222222';
export const pawGreen: Color = '#237804';
